import { getBridge } from './bridge';

/**
 * Route an outbound link through the native shell when present.
 *
 * In the Capacitor shell, `target="_blank"` anchors are dead (there is no
 * window.open surface) and, per the Amazon Associates Mobile Application
 * Policy, Amazon destinations must never render inside an in-app browser —
 * the shell's openExternal decides full external browser (Amazon/Audible)
 * vs SFSafariViewController / Custom Tabs (other retailers) per host.
 *
 * Returns true when the shell handled the navigation — the caller must then
 * preventDefault on the anchor event. Returns false in a normal browser so
 * the existing <a target="_blank"> behavior is untouched.
 */
export function openExternalViaShell(url: string): boolean {
  const bridge = getBridge();
  if (!bridge) return false;
  // Untrusted-input boundary: only ever hand the shell absolute http(s) URLs.
  if (!/^https?:\/\//i.test(url)) return false;
  void bridge.openExternal(url).catch((error) => {
    console.error('bridge.openExternal failed:', error);
  });
  return true;
}
